import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-91" data-mp="4ui155ec6zin">
      <div className="mx-auto max-w-3xl px-4" data-id="element-92" data-mp="9umiexn2jy9x">
        <div className="rounded-2xl border border-[var(--gold)]/40 bg-[#12140b] p-8 text-center sm:p-12" data-id="element-93" data-mp="9srvjds8lw37">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[var(--gold)]/15" data-id="element-94" data-mp="ev0o49176w4s">
            <ShieldCheckIcon className="h-9 w-9 text-[var(--gold)]" aria-hidden="true" data-id="element-95" data-mp="jqg1kzvamq0o" />
          </span>
          <h2 className="mt-6 font-serif-display text-3xl font-bold text-[var(--cream)] sm:text-4xl" data-id="element-96" data-mp="skkoj87b3hax">
            Garantía 7 días — Sin preguntas
          </h2>
          <p className="mt-5 text-white/75" data-id="element-97" data-mp="xlrxhal6qmj6">
            Abrís los tomos. Los usás en el mat.
          </p>
          <p className="mt-2 text-white/75" data-id="element-98" data-mp="17i4og0pcima8">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="mt-4 text-lg font-semibold text-[var(--gold-light)]" data-id="element-99" data-mp="25rniaxguqis8">
            Devolución del 100% · Sin formularios · Sin drama.
          </p>
          <p className="mt-4 text-sm text-white/50" data-id="element-100" data-mp="20r9angj5xauq">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}